import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { DeviceEvent } from 'src/app/data/model/device-event';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule
})
export class DeviceEventMapApiService extends CrudApiService<DeviceEvent> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('data/telemetries/portal-device-event-map', http, config);
  }
}
